// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="(\$ctrl.commandGroup | translateEnum:'LABEL') + ' actions'"></sub-header>

  <div class="filters">
    <div class="labelled-field">
      <label>Action</label>
      <input type="text"
             ng-model="\$ctrl.commandFilter.displayName"/>
    </div>
    <div class="flex-end">
      <button type="button"
              ng-click="\$ctrl.addAccessRule()"
              class="btn btn-success">
        Add
      </button>
    </div>
  </div>

  <div class="table-content">
    <table class="table" ng-table="\$ctrl.tableConfig">
      <tbody>
      <tr ng-repeat="rule in \$data | orderBy:'displayName'" class="rule">
        <td class="name">
          {{rule.displayName}}<br/>
        </td>
        <td>
          <div class="predicates">
            <div ng-repeat="(accessInput, _) in rule.predicates['GREATER_THAN_AMOUNT']">
              <amount-predicate ng-disabled="true" predicates="rule.predicates"
                                rule-definitions="\$ctrl.getAccessRuleDefinition(rule.command)"
                                type="'GREATER_THAN_AMOUNT'"
                                access-input="accessInput">
              </amount-predicate>
            </div>
            <div ng-repeat="(accessInput, _) in rule.predicates['GREATER_THAN_OR_EQUAL_AMOUNT']">
              <amount-predicate ng-disabled="true" predicates="rule.predicates"
                                rule-definitions="\$ctrl.getAccessRuleDefinition(rule.command)"
                                type="'GREATER_THAN_OR_EQUAL_AMOUNT'"
                                access-input="accessInput">
              </amount-predicate>
            </div>
            <div ng-repeat="(accessInput, _) in rule.predicates['LESS_THAN_AMOUNT']">
              <amount-predicate ng-disabled="true" predicates="rule.predicates"
                                rule-definitions="\$ctrl.getAccessRuleDefinition(rule.command)"
                                type="'LESS_THAN_AMOUNT'"
                                access-input="accessInput">
              </amount-predicate>
            </div>
            <div ng-repeat="(accessInput, _) in rule.predicates['LESS_THAN_OR_EQUAL_AMOUNT']">
              <amount-predicate ng-disabled="true" predicates="rule.predicates"
                                rule-definitions="\$ctrl.getAccessRuleDefinition(rule.command)"
                                type="'LESS_THAN_OR_EQUAL_AMOUNT'"
                                access-input="accessInput">
              </amount-predicate>
            </div>

            <div ng-repeat="(accessInput, _) in rule.predicates['BRANCH_ACCESS_MODE']">
              <mother-branch-predicate type="'BRANCH_ACCESS_MODE'"
                                       ng-disabled="true"
                                       predicates="rule.predicates"
                                       rule-definitions="\$ctrl.getAccessRuleDefinition(rule.command)"
                                       access-input="accessInput">
              </mother-branch-predicate>
            </div>

            <div ng-repeat="(accessInput, _) in rule.predicates['USER_ACCESS_MODE']">
              <user-predicate ng-disabled="true"
                              predicates="rule.predicates"
                              rule-definitions="\$ctrl.getAccessRuleDefinition(rule.command)"
                              access-input="accessInput">
              </user-predicate>
            </div>

            <div ng-repeat="(accessInput, _) in rule.predicates['IN']">
              <product-status-predicate ng-disabled="true"
                                        predicates="rule.predicates"
                                        rule-definitions="\$ctrl.getAccessRuleDefinition(rule.command)"
                                        access-input="accessInput"
                                        ng-if="accessInput === 'PRODUCT_STATUS'"
                                        type="'IN'">
              </product-status-predicate>
              <product-definition-predicate ng-disabled="true"
                                            predicates="rule.predicates"
                                            rule-definitions="\$ctrl.getAccessRuleDefinition(rule.command)"
                                            access-input="accessInput"
                                            command-group="\$ctrl.commandGroup"
                                            ng-if="accessInput === 'PRODUCT_DEFINITION'"
                                            type="'IN'">
              </product-definition-predicate>
              <mother-branch-predicate type="'IN'"
                                       ng-disabled="true"
                                       predicates="rule.predicates"
                                       rule-definitions="\$ctrl.getAccessRuleDefinition(rule.command)"
                                       access-input="accessInput"
                                       ng-if="accessInput === 'PRODUCT_BRANCH_ACCESS'">
              </mother-branch-predicate>
            </div>

            <div ng-repeat="(accessInput, _) in rule.predicates['EQUALS']">
              <boolean-predicate ng-disabled="true"
                                 type="'EQUALS'"
                                 predicates="rule.predicates"
                                 rule-definitions="\$ctrl.getAccessRuleDefinition(rule.command)"
                                 access-input="accessInput"
                                 ng-if="accessInput !== 'AGENT_PAYMENT_MODE'">
              </boolean-predicate>

              <agent-payment-mode-predicate ng-disabled="true"
                                            predicates="rule.predicates"
                                            rule-definitions="\$ctrl.getAccessRuleDefinition(rule.command)"
                                            access-input="accessInput"
                                            ng-if="accessInput === 'AGENT_PAYMENT_MODE'"
                                            type="'EQUALS'">
              </agent-payment-mode-predicate>
            </div>

          </div>
        </td>
        <td class="flags">
          <div><input type="checkbox" ng-model="rule.approve" disabled>Can approve</div>
          <div><input type="checkbox" ng-model="rule.otpRequired" disabled>Requires OTP</div>
          <div><input type="checkbox" ng-model="rule.allowedOnHoliday" disabled>Allowed on non-working day</div>
          <div>
            <select ng-model="rule.executionType"
                    ng-options="o.value as o.label for o in \$ctrl.getExecuteOptions(rule)"
                    class="role-write-access__execution_type"
                    required
                    disabled>
            </select>
          </div>
        </td>
        <td>
          <div class="role-write-access_buttons">
            <button type="button"
                    class="btn btn-primary"
                    ng-click="\$ctrl.editAccessRule(rule)">
              Edit
            </button>
            <button type="button" class="btn btn-danger" ng-click="\$ctrl.removeAccessRule(rule)">
              Remove
            </button>
          </div>
        </td>
      </tr>
      </tbody>
    </table>

  </div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/security/role-write-access/group/grouped-role-write-access-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;